import axios from 'axios';
import { message } from 'antd';
import {
  EMPLOYEE_API
} from '../../../constants/API';
import {
  CREATE_EMPLOYEE_LOADING
} from '../types';


function createEmployee(data) {
  return async(dispatch, getState) => {
      dispatch({
        type: CREATE_EMPLOYEE_LOADING,
        creatingEmployee: true
      });
      try {
        const accessToken = await localStorage.getItem('accessToken');
        const { userData } = getState().AuthReducer;
        const postData = {
          ...data,
          userId: userData.id
        };
        const employeeResponse = await axios.post(EMPLOYEE_API, postData, { headers: {"Authorization" : `Bearer ${accessToken}`} });
        const { id } = employeeResponse.data

        dispatch({
          type: CREATE_EMPLOYEE_LOADING,
          creatingEmployee: false
        });
        return id;
      } catch (e) {
        message.error(String(e));
        dispatch({
          type: CREATE_EMPLOYEE_LOADING,
          creatingEmployee: false
        });
        console.log(e);
      }
  }
}
export default createEmployee;
